export default "__VITE_ASSET__XsKKWhEe__"